import(/* webpackMode: "eager" */ "/var/www/turivana/frontend/src/app/[locale]/cart/page.tsx");
